<template>
  <v-card
   class="mx-auto pa-0 my-12 col-sm-10  offset-md-0 col-12 offset-0"
   elevation="0"
   >
  <v-row class="text-center pa-0 " no-gutters>

    <!-- ряд 1 сектор 1 -->
    <v-col class="white col-md-6 offset-md-0 col-12 offset-0">

   
    <!-- :src="require('../assets/contacts.jpg')" -->
    <v-img
      
      src="https://firebasestorage.googleapis.com/v0/b/pravo-na-jizn.appspot.com/o/contacts%2Fcontacts.jpg?alt=media&token=310fa7de-cd28-4afa-a7c3-b2915f6dc319"
      width="100%"
      height="auto"
    >
    </v-img>

    </v-col>

    <!-- ряд 1 сектор 2 -->
    <v-col class="ma-0 pa-0 col-xs-11 col-sm-8 col-md-6 col-lg-5 " >
      <v-card-title 
        class="mx-8 px-auto pt-5 mb-0 blue-grey--text text-md-h5 text-sm-h5 text-xs-h6 font-weight-bold textWordBreak"
      >Контактная информация</v-card-title>

      <v-card-text >
        <!-- <div class="font-weight-bold ml-8 mb-2">
          Today
        </div> -->

        <v-timeline
          align-center
          dense
        >
          <v-timeline-item
            v-for="item in items"
            :key="item.phone"
            :color="item.color"
            small
          >
            <v-card 
              :color="item.color" 
              dark  
              height="100%" 
              width="auto"
            >
              <v-row class="pl-2 py-0 align-center" >
                <v-flex xs10 sm10 md5 offset-sm1 offset-md0>
                  <v-card-title class="text-left subtitle-1 pl-3 py-0 textWordBreak">
                    {{ item.name }}
                  </v-card-title>
                </v-flex>
                <v-flex xs10 sm10 md7 offset-sm1 offset-md0>
                  <v-card-title class="text-right subtitle-1 pl-3 py-0 textWordBreak">
                    {{ item.phone }}
                  </v-card-title>
                </v-flex>
              </v-row>
            </v-card>

          </v-timeline-item>
        </v-timeline>
      </v-card-text>
    </v-col>
  </v-row>

  <v-container fluid> 
  <v-divider  class="mx-auto mb-1 mt-5 "></v-divider>
    <v-divider  class="mx-auto mb-5 mt-0"></v-divider>
  </v-container>


  <!-- 3-й ряд -->
  <v-row class="text-center py-0 px-4 " no-gutters>
    <v-col class="mx-0 pa-0 col-12 offset-0">
      <v-card  
        class="brown lighten-4 justify-center align-center text-center"
        to="sos"
      >

        <v-img
          contain
          aspect-ratio="3.9"
          style="background-image: url(https://firebasestorage.googleapis.com/v0/b/pravo-na-jizn.appspot.com/o/contacts%2Fcontacts2.jpg?alt=media&token=636768f2-8711-4185-bf47-2b361cffa901); background-position: center center; background-size: cover;"
        >
        </v-img>

        <v-card-text  class="py-1 textColor  text-md-h5 text-sm-h5 text-xs-h6 font-weight-bold  text-left textWordBreak">
        Мы очень нуждаемся в Вашей помощи...
        </v-card-text>

      </v-card>

    </v-col>
  </v-row>


<v-container fluid> 
  <v-divider  class="mx-auto mb-1 mt-5 "></v-divider>
    <v-divider  class="mx-auto mb-3 mt-0"></v-divider>
  </v-container>


   <v-row justify="center" no-gutters>
      <!-- ряд 2 сектор 1 -->
      <v-col
        class=" px-1 col-md-6 offset-md-0 col-12 offset-0"
      >
        <div
          class="mx-3 my-3"
        >
        <v-card  class="#597da3 justify-center align-center text-center" >
          <v-card-title
            class="textTimelineHeaders textWordBreak justify-center "
            style="color: white; background-color: #597da3;"
          >
          <!-- 616161 -->
          <a target="blank" class="white--text text-decoration-none"  href="https://vk.com/pravo_na_zhiznye">
          <strong>В</strong>Контакте</a>
          </v-card-title>
            <div class="justify-center align-center text-center">
              <vk-comment></vk-comment>
            </div>
        </v-card>
        </div>
      </v-col>

        <!-- ряд 2 сектор 2 -->
      <v-col
        class=" px-1 col-md-6 offset-md-0 col-12 offset-0"
      >
        <div
          class="mx-3 my-3"
        >
          <v-card class="teal justify-center align-center text-center" >
            <v-card-title
              class=" textTimelineHeaders textWordBreak justify-center"
              style="color: white"
            >
             <strong>В</strong> Полоцке
            </v-card-title>
            <div class="justify-center align-center text-center">
              <y-map></y-map>
            </div>
          </v-card>
        </div>
      </v-col>
    </v-row>

  

  

</v-card>

</template>



<script>
import YMap from "../components/Map.vue";
import VkComment from "../components/VkComment.vue";
export default {
  name: "Contacts",
  data() {
    return {
      items: [
        {
          name: "Вероника",
          color: "red lighten-2",
          icon: "mdi-star",
          phone: "+375 33 646-90-67",
        },
        {
          name: "Наталья Ивановна",
          color: "indigo",
          icon: "mdi-book-variant",
          phone: "+375 33 679-83-10",
        },
        {
          name: "Елена",
          color: "green lighten-1",
          icon: "mdi-airballoon",
          phone: "+375 29 292-40-42",
        },
      ],
       messages: [
        {
          name: 'You',
          phone: `Sure, I'll see you later.`,
          time: '10:42am',
          color: 'deep-purple lighten-1',
        },
        {
          name: 'John Doe',
          phone: 'Yeah, sure. Does 1:00pm work?',
          time: '10:37am',
          color: 'green',
        },
        {
          name: 'You',
          phone: 'Did you still want to grab lunch today?',
          time: '9:47am',
          color: 'deep-purple lighten-1',
        },
      ],
    };
  },

  components: {
    YMap,
    VkComment,
  },


};
</script>

<style scoped>

.border-style {
  border: 4px solid #ECEFF1;
}
 
</style>
